module.exports = __webpack_public_path__ + "img/img8.89f9d60a.svg";